import type { StepperStepProps } from "./types-step";
import { useStepperStep } from "./use-step";
import { StepperStepView } from "./view-step";

export function StepperStep(props: StepperStepProps) {
  const viewModel = useStepperStep(props);

  return <StepperStepView {...viewModel} />;
}
StepperStep.displayName = "Stepper.Step";
